import { useState } from "react";

// Api's
import { translateApi } from "../api";

// Models
import { KeyValue } from "../models/common";

// Utils
import { getCultureBrowser, composeTranslates } from "../services/utils";
import {
	LASTSYNCTRANSLATIONS,
	TRANSLATIONS,
	getStorage,
	saveArrayStorage,
	saveStringStorage,
} from "../services/storage";

// Models
import { TranslateCultureRequest } from "../models/request";

interface IUseTranslateHookProps {
	filter?: Omit<TranslateCultureRequest, "culture" | "lastSyncTranslations">;
	fillTranslateLocal: boolean;
}

interface IGetTranslates {
	culture?: string | null;
	lastSyncTranslations?: string | null;
}

export function useTranslateHook({ filter = {}, fillTranslateLocal }: IUseTranslateHookProps) {
	const [isLoadingTranslates, setIsLoadingTranslates] = useState(true);
	const [translatesLocal, setTranslatesLocal] = useState<KeyValue[]>([]);
	const cultureBrowser = getCultureBrowser();

	async function getTranslates(filterTranslates: IGetTranslates = {}) {
		const { culture, lastSyncTranslations = null } = filterTranslates;

		const cultureFilter = culture && culture !== null ? culture : cultureBrowser;

		setIsLoadingTranslates(true);
		const request: TranslateCultureRequest = {
			...filter,
			culture: cultureFilter,
			lastSyncTranslations,
		};
		const responseApi = await translateApi.getTranslates(request);

		if (fillTranslateLocal) {
			const keyTranslateStorage = `${TRANSLATIONS}_${cultureFilter}`;
			const dataTranslateStorage = getStorage(keyTranslateStorage);

			if (
				responseApi.data.result &&
				responseApi.data.result.translations &&
				responseApi.data.result.translations.length > 0
			) {
				const translatesResultApi = responseApi.data.result.translations;
				const translatesData = composeTranslates(cultureFilter, translatesResultApi);
				if (translatesData.length === 0) {
					setTranslatesLocal(translatesResultApi);

					// Save local storage
					saveArrayStorage(keyTranslateStorage, translatesResultApi);
				} else {
					setTranslatesLocal(composeTranslates(cultureFilter, translatesResultApi));
				}

				// Save last sync date
				saveStringStorage(`${LASTSYNCTRANSLATIONS}_${cultureFilter}`, responseApi.data.result.lastSyncTranslations);
			} else {
				setTranslatesLocal(dataTranslateStorage);
			}
		}

		setIsLoadingTranslates(false);
		return responseApi;
	}

	return {
		isLoadingTranslates,
		translatesLocal,
		getTranslates,
	};
}
